//  -*-web-*-
import {React, Component} from 'react';
import Chart from "react-google-charts";
import { ChartOptions } from "./ChartOptions.js";

let debug = false; // If true then debug messages are logged on the console

// --------------------------------------------------------------------
// Class which implements a Google Chart of our data
// --------------------------------------------------------------------
export class ChartArea extends Component {
    
    // --------------------------------------------------------------------
    // Construct an object and initiate the internal React state
    // --------------------------------------------------------------------
    constructor(props) {
	super(props);
	this.state = {
	    status: "init",
	    appState: props.appState,
	    url: props.url,
	    data: null,
	    size: props.size,
	    options: {height: 400},
	    error: null
	};
    }

    // --------------------------------------------------------------------
    // Update the state object if properties have changed
    // --------------------------------------------------------------------
    static getDerivedStateFromProps(props, state) {
	var newstate = {};
	var updated = false;
	var msg = state.status;
	if (props.url !== state.url) {
	    newstate['status'] = "loading";
	    newstate['url'] = props.url;
	    //newstate['data'] = null;
	    updated = true;
	    msg =" url-change";
	}
	if (props.size.width !== state.size.width ||
	    props.size.height !== state.size.height) {
	    newstate['size'] = props.size;
	    if (state.data !== null) {
		const options = new ChartOptions(state.appState(), state.data,
						 props.size, false);
		newstate['options'] = options.getOpt();
	    }
	    updated = true;
	    msg += " size-update";
	}
	if (debug) console.log("getDerivedStateFromProps: " + msg);
	// Return null if no state update is necessary
	if (!updated) newstate = null;
	return newstate;
    }

    // --------------------------------------------------------------------
    // Fired after the chart is displayed for the first time. Initiates
    // an asynchronous request to fetch data form the external data source.
    // --------------------------------------------------------------------
    componentDidMount() {
	if (debug) console.log("componentDidMount: " + this.state.status);
	this.updateData();
    }

    // --------------------------------------------------------------------
    // Asynchronous request to our data source. When the data is received
    // the state is updated, triggering a re-rendering in React
    // --------------------------------------------------------------------
    async updateData() {
	if (debug) console.log("updateData: fetching data");
	fetch(this.state.url)
	    .then(res => res.json())
	    .then(
		(result) => {
		    if (debug) console.log("updateData: data received");
		    const data = result;
		    const options = new ChartOptions(this.state.appState(),
						     data, this.state.size);
		    this.setState({
			options: options.getOpt(),
			status: "ready",
			data: data
		    });
		},
		(error) => {
		    this.setState({
			status: "ready",
			error: error
		    });
		}
	    );
    }
    
    // --------------------------------------------------------------------
    // Render our chart provided there is data available and no error is set
    // --------------------------------------------------------------------
    render() {
	const { error, data, options } = this.state;
	if (error !== null) {
	    if (debug) console.log("render: " + error.message);
	    return <div>Error: {error.message}</div>;
	} else if (data === null) {
	    if (debug) console.log("render: data===null");
	    return <div></div>;
	} else {
	    if (debug) console.log("render: drawing / " + this.state.status);
	    return (
		<div style={{height: options.height + 'px'}} >
		<Chart
		chartType="ComboChart"
		data={data}
		options={options}
		/>
		</div>
	    );
	}
    }
    
    // --------------------------------------------------------------------
    // Fired after the component has been updated. Requests external data
    // if we are in a loading state.
    // --------------------------------------------------------------------
    componentDidUpdate(prevProps, prevState) {
	if (debug) console.log("componentDidUpdate: " + this.state.status);
	if (this.state.status === "loading") {
	    this.updateData();
	}
    }

    // --------------------------------------------------------------------
    // Fired before unmounting a component
    // --------------------------------------------------------------------
    componentWillUnmount() {
	if (debug) console.log("componentWillUnmount");
	// Cancel chart async request
    }
}

